import { useState } from 'react';
import { TypeAhead } from '@components/TypeAhead';
import { IconSearch } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const TypeAheadSection = () => {
  const [typeAheadValue, setTypeAheadValue] = useState<string | null>(null);

  return (
    <section className={styles.section}>
      <SectionHeader
        title="TypeAhead"
        description="A searchable dropdown that combines Input and MenuSelect. Type to filter options, click to select."
        figmaNodeId="281-2042"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive TypeAhead</h3>
        <div className={styles.typeAheadContainer}>
          <TypeAhead
            items={[
              { value: 'la', label: 'Los Angeles (US)' },
              { value: 'sf', label: 'San Francisco (US)' },
              { value: 'sd', label: 'San Diego (US)' },
              { value: 'sj', label: 'San Jose (US)' },
              { value: 'ny', label: 'New York (US)' },
              { value: 'chi', label: 'Chicago (US)' },
              { value: 'hou', label: 'Houston (US)' },
              { value: 'sc', label: 'Santiago (CL)' },
            ]}
            value={typeAheadValue}
            onChange={setTypeAheadValue}
            placeholder="Search cities..."
          />
        </div>
        <p className={styles.hint}>
          Selected: <strong>{typeAheadValue || 'None'}</strong>
        </p>
        <p className={styles.hint}>Try typing "San" to filter results</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>With Search Icon</h3>
        <div className={styles.typeAheadContainer}>
          <TypeAhead
            items={[
              { value: 'opt1', label: 'Option 1' },
              { value: 'opt2', label: 'Option 2' },
              { value: 'opt3', label: 'Option 3' },
            ]}
            placeholder="Search options..."
            leadingIcon={<IconSearch size={18} />}
          />
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Disabled</h3>
        <div className={styles.typeAheadContainer}>
          <TypeAhead
            items={[
              { value: 'a', label: 'Item A' },
              { value: 'b', label: 'Item B' },
            ]}
            placeholder="Disabled..."
            disabled
          />
        </div>
      </div>
    </section>
  );
};
